@for (filter of customReport().staticFilters; track $index) {
  <pr-query-filter-display [values]="filter | map: getFilterSummary : this" />
}

<ng-content />
